/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2024 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Götz Görisch, VDW - Verein Deutscher Werkzeugmaschinenfabriken e.V.
 */
import React, { Component } from 'react';
import URLs from '../../utilities/URLs';
import MachineList from '../../views/machineList';
import '../../styles/tvViewMapList.scss';
import { labels } from '@umati/dashboard-common';

class TvViewMapList extends Component {
  render() {
    return (
      <div className="tv-map-list">
        <div className="header-title header">
          <h1>{`${labels.fairMapView} ${this.props.fair?.Name}`}</h1>
          <h3>{labels.subtitleTvViewMapList}</h3>
        </div>
        <div className="header-logo">
          <img alt="" src={this.props.fair?.ImageFile} />
        </div>
        <div className="header-border"></div>
        <div className="map">
          {this.props.fair?.Tag && (
            <img src={URLs.getFairMapBucket(this.props.fair?.Tag, this.props.staticBucketReachable)} alt="" />
          )}
        </div>
        <div className="machines">
          <MachineList {...this.props} hidden={true} />
        </div>
      </div>
    );
  }
}

export default TvViewMapList;
